import type { StateMetadata } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';
import type { IBackwardCompatibilityHandler } from './CasePersistenceHub';
import type { VertexInfo } from '@/engine/DataFlow/DataFlow';

export class PlanningAlgorithmCompatibilityHandler implements IBackwardCompatibilityHandler {
  public handleMetadata(metadata: unknown /*, version?: string*/): Promise<unknown> {
    const metaIn = metadata as {
      dataFlow: Array<VertexInfo>;
    };
    const metaOut: StateMetadata = {
      dataFlow: metaIn.dataFlow,
      dataFlowExtensions: [],
      approvedNames: []
    };
    return Promise.resolve(metaOut);
  }
}
